import createActionTypes from 'utils/createActionTypes'

export default createActionTypes('writingLesson', ['SET_STEP_MAP'])
